module.exports = __webpack_public_path__ + "img/plus-square.94940753.svg";